import EnvelopeCreate from '@/views/envelope-create/EnvelopeCreate.vue';
import EnvelopeInstantiate from '@/views/envelope-create/EnvelopeInstantiate.vue';
import EnvelopeStatus from '@/views/EnvelopeStatus.vue';
import EnvelopeUpdate from '@/views/EnvelopeUpdate.vue';

export default [
  {
    path: '/envelope/create',
    redirect: '/envelopes/create',
    name: 'EnvelopeInstantiate',
    component: EnvelopeInstantiate,
    meta: {
      title: 'envelopeCreate',
      icon: 'envelope-open',
      requiresAuth: true,
    },
  },
  {
    path: '/envelope/create/:envelopeFingerprint',
    redirect: '/envelopes/:envelopeFingerprint',
    name: 'EnvelopeCreate',
    component: EnvelopeCreate,
    meta: {
      title: 'envelopeCreate',
      icon: 'envelope-open',
      requiresAuth: true,
    },
  },
  {
    path: '/envelope/:envelopeFingerprint',
    name: 'EnvelopeStatus',
    component: EnvelopeStatus,
    meta: {
      title: 'envelopeStatus',
      icon: 'envelope',
      requiresAuth: true,
    },
  },
  {
    path: '/envelope/:envelopeFingerprint/download',
    redirect: {
      path: '/envelope/:envelopeFingerprint',
      query: {
        download_envelope: true,
      },
    },
  },
  {
    path: '/envelope/update/:envelopeFingerprint',
    name: 'EnvelopeUpdate',
    component: EnvelopeUpdate,
    meta: {
      title: 'envelopeUpdate',
      icon: 'pencil',
      requiresAuth: true,
    },
  },
];
